<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('vitalSigns.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="time-box">
                <div class="time-item" :class="{'time-active': activeTime === 1}"
                     @click="changeTimeType(1)">{{ $t('dailyActive.time0') }}
                </div>
                <div class="time-item" :class="{'time-active': activeTime === 2}"
                     @click="changeTimeType(2)">{{ $t('dailyActive.time1') }}
                </div>
                <div class="time-item" :class="{'time-active': activeTime === 3}"
                     @click="changeTimeType(3)">{{ $t('dailyActive.time2') }}
                </div>
            </div>
            <div class="time-select">
                <img @click="timeLeft" class="time-icon" :class="{'arr-opacity' : showLeftOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/03left.svg`)">
                <div class="time-date">{{ time }}</div>
                <img @click="timeRight" class="time-icon" :class="{'arr-opacity' : showRightOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/04right.svg`)">
                <div class="chart-unit" v-if="mathData.avgData">{{ $t('hr.unit') }}</div>
            </div>
            <div id="chart-box"></div>
        </div>
        <div class="suggest-title">{{ $t('recovery.heartRate') }}
            <img class="info-icon"
                 :src="require(`@/assets/theme/${theme}/status/06sleep/01info.svg`)">
        </div>
        <div class="score-chart-box">
            <div class="avg-duration-title">{{ $t('recovery.avgHeartRate') }}</div>
            <div class="vs-line">
                <div class="avg-efficiency-line">
                    <div class="avg-efficiency-value">{{
                            noData ? '--' : (info.vitalSignsRangeMath && info.vitalSignsRangeMath.hrAvg != null ? Math.ceil(info.vitalSignsRangeMath.hrAvg) : '--')
                        }}
                    </div>
                    <div class="avg-efficiency-unit">bpm</div>
                    <div class="avg-efficiency-compare"
                         v-if="!noData && info.vitalSignsRangeMath && info.vitalSignsRangeMath.hrAvgLast != null">
                        <img
                            :src="info.vitalSignsRangeMath.hrAvg >= info.vitalSignsRangeMath.hrAvgLast ? require('@/assets/theme/light/status/06sleep/08up.svg') : require('@/assets/theme/light/status/06sleep/08down.svg')">
                        <span class="avg-efficiency-compare-value">{{
                                Math.abs(info.vitalSignsRangeMath.hrAvg - info.vitalSignsRangeMath.hrAvgLast).toFixed(1)
                            }}</span>
                    </div>
                </div>
                <div class="vs-text">{{
                        $t(activeTime === 2 ? 'sleep.vsLastMonthTitle' : 'sleep.vsLastWeekTitle')
                    }}
                </div>
            </div>
            <div class="hr-chart" id="hr-avg-chart"></div>
        </div>
        <div class="suggest-title">{{ $t('recovery.restingHr') }}
            <img class="info-icon"
                 :src="require(`@/assets/theme/${theme}/status/06sleep/01info.svg`)">
        </div>
        <div class="score-chart-box">
            <div class="avg-duration-title">{{ $t('recovery.avgRestingHr') }}</div>
            <div class="vs-line">
                <div class="avg-efficiency-line">
                    <div class="avg-efficiency-value">{{
                            noData ? '--' : (info.vitalSignsRangeMath && info.vitalSignsRangeMath.hrDeepAvg != null ? Math.ceil(info.vitalSignsRangeMath.hrDeepAvg) : '--')
                        }}
                    </div>
                    <div class="avg-efficiency-unit">bpm</div>
                    <div class="avg-efficiency-compare"
                         v-if="!noData && info.vitalSignsRangeMath && info.vitalSignsRangeMath.hrDeepAvgLast != null">
                        <img
                            :src="info.vitalSignsRangeMath.hrDeepAvg >= info.vitalSignsRangeMath.hrDeepAvgLast ? require('@/assets/theme/light/status/06sleep/08up.svg') : require('@/assets/theme/light/status/06sleep/08down.svg')">
                        <span class="avg-efficiency-compare-value">{{
                                Math.abs(info.vitalSignsRangeMath.hrDeepAvg - info.vitalSignsRangeMath.hrDeepAvgLast).toFixed(1)
                            }}</span>
                    </div>
                </div>
                <div class="vs-text">{{
                        $t(activeTime === 2 ? 'sleep.vsLastMonthTitle' : 'sleep.vsLastWeekTitle')
                    }}
                </div>
            </div>
            <div class="hr-chart" id="hr-chart"></div>
        </div>
        <div class="suggest-title">{{ $t('recovery.hrv') }}
            <img class="info-icon"
                 :src="require(`@/assets/theme/${theme}/status/06sleep/01info.svg`)">
        </div>
        <div class="score-chart-box">
            <div class="avg-duration-title">{{ $t('recovery.avgHrv') }}</div>
            <div class="vs-line">
                <div class="avg-efficiency-line">
                    <div class="avg-efficiency-value">{{
                            noData ? '--' : (info.vitalSignsRangeMath && info.vitalSignsRangeMath.hrvAvg != null ? Math.ceil(info.vitalSignsRangeMath.hrvAvg) : '--')
                        }}
                    </div>
                    <div class="avg-efficiency-unit">ms</div>
                    <div class="avg-efficiency-compare"
                         v-if="!noData && info.vitalSignsRangeMath && info.vitalSignsRangeMath.hrvAvgLast != null">
                        <img
                            :src="info.vitalSignsRangeMath.hrvAvg >= info.vitalSignsRangeMath.hrvAvgLast ? require('@/assets/theme/light/status/06sleep/08up.svg') : require('@/assets/theme/light/status/06sleep/08down.svg')">
                        <span class="avg-efficiency-compare-value">{{
                                Math.abs(info.vitalSignsRangeMath.hrvAvg - info.vitalSignsRangeMath.hrvAvgLast).toFixed(1)
                            }}</span>
                    </div>
                </div>
                <div class="vs-text">{{
                        $t(activeTime === 2 ? 'sleep.vsLastMonthTitle' : 'sleep.vsLastWeekTitle')
                    }}
                </div>
            </div>
            <div class="hr-chart" id="hrv-chart"></div>
        </div>
        <div class="suggest-title">{{ $t('recovery.respiratoryRate') }}
            <img class="info-icon"
                 :src="require(`@/assets/theme/${theme}/status/06sleep/01info.svg`)">
        </div>
        <div class="score-chart-box">
            <div class="avg-duration-title">{{ $t('recovery.avgRespiratoryRate') }}</div>
            <div class="vs-line">
                <div class="avg-efficiency-line">
                    <div class="avg-efficiency-value">{{
                            noData ? '--' : (info.vitalSignsRangeMath && info.vitalSignsRangeMath.respRateDeepAvg != null ? Math.ceil(info.vitalSignsRangeMath.respRateDeepAvg) : '--')
                        }}
                    </div>
                    <div class="avg-efficiency-unit"></div>
                    <div class="avg-efficiency-compare"
                         v-if="!noData && info.vitalSignsRangeMath && info.vitalSignsRangeMath.respRateDeepAvgLast != null">
                        <img
                            :src="info.vitalSignsRangeMath.respRateDeepAvg >= info.vitalSignsRangeMath.respRateDeepAvgLast ? require('@/assets/theme/light/status/06sleep/08up.svg') : require('@/assets/theme/light/status/06sleep/08down.svg')">
                        <span class="avg-efficiency-compare-value">{{
                                Math.abs(info.vitalSignsRangeMath.respRateDeepAvg - info.vitalSignsRangeMath.respRateDeepAvgLast).toFixed(1)
                            }}</span>
                    </div>
                </div>
                <div class="vs-text">{{
                        $t(activeTime === 2 ? 'sleep.vsLastMonthTitle' : 'sleep.vsLastWeekTitle')
                    }}
                </div>
            </div>
            <div class="hr-chart" id="resp-chart"></div>
        </div>
    </div>
</template>

<script>
import {getQueryVariable, getSkin} from '@/utils/comment'
import {
    getNWeekFirstDay,
    getNWeekLastDay,
    getMonthStartDay,
    getMonthEndDay,
    GetDateStr,
    changeMonthDate,
    GetYear, getDateWeek, getDateDay
} from "../../utils/dateUtils";
import {WebJSBridge} from "../../utils/JSBridge1";

export default {
    name: 'vitalSignsRange',
    data() {
        return {
            ratio: 1,
            theme: getQueryVariable("theme") ? getQueryVariable("theme") : "light",
            activeTime: 1,
            time: '',
            startDate: '',
            endDate: '',
            tNum: 0,
            wNum: 0,
            mNum: 0,
            yNum: 0,
            info: {},
            mathData: {},
            showLeftOpacity: 0,
            showRightOpacity: 1,
            noData: false,
        }
    },
    mounted() {
        this.ratio = document.body.clientWidth / 375 ? document.body.clientWidth / 375 : 1;
        this.startDate = getNWeekFirstDay(this.wNum);
        this.endDate = getNWeekLastDay(this.wNum);
        this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
        this.getData();
    },
    methods: {
        back() {
            this.$router.back()
        },
        checkOpacity() {
            if (this.activeTime == 0 && this.tNum <= 0) {
                this.showRightOpacity = 1
            } else if (this.activeTime == 1 && this.wNum >= 0) {
                this.showRightOpacity = 1
            } else if (this.activeTime == 2 && this.mNum >= 0) {
                this.showRightOpacity = 1
            } else if (this.activeTime == 3 && this.yNum >= 0) {
                this.showRightOpacity = 1
            } else {
                this.showRightOpacity = 0
            }
            if (this.activeTime == 0 && this.startDate <= '2020-01-01') {
                this.showLeftOpacity = 1
            } else if (this.activeTime == 1 && this.startDate <= '2020-01-01') {
                this.showLeftOpacity = 1
            } else if (this.activeTime == 2 && this.startDate <= '2020-01-01') {
                this.showLeftOpacity = 1
            } else if (this.activeTime == 3 && GetYear(this.yNum - 1) <= 2019) {
                this.showLeftOpacity = 1
            } else {
                this.showLeftOpacity = 0
            }
        },
        timeLeft() {
            if (this.activeTime == 0 && this.startDate > '2020-01-01') {
                this.tNum++;
                this.startDate = GetDateStr(this.tNum);
                this.endDate = GetDateStr(this.tNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 1 && this.startDate > '2020-01-01') {
                this.wNum--;
                this.startDate = getNWeekFirstDay(this.wNum);
                this.endDate = getNWeekLastDay(this.wNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 2 && this.startDate > '2020-01-01') {
                this.mNum--;
                this.startDate = getMonthStartDay(this.mNum);
                this.endDate = getMonthEndDay(this.mNum);
                this.time = changeMonthDate(this.startDate);
            } else if (this.activeTime == 3 && GetYear(this.yNum - 1) > 2026) {
                this.yNum--;
                this.startDate = GetYear(this.yNum);
                this.time = GetYear(this.yNum);
            }
            this.getData();
            this.checkOpacity();
        },
        timeRight() {
            if (this.activeTime == 0 && this.tNum > 0) {
                this.tNum--;
                this.startDate = GetDateStr(this.tNum);
                this.endDate = GetDateStr(this.tNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 1 && this.wNum < 0) {
                this.wNum++;
                this.startDate = getNWeekFirstDay(this.wNum);
                this.endDate = getNWeekLastDay(this.wNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 2 && this.mNum < 0) {
                this.mNum++;
                this.startDate = getMonthStartDay(this.mNum);
                this.endDate = getMonthEndDay(this.mNum);
                this.time = changeMonthDate(this.startDate);
            } else if (this.activeTime == 3 && this.yNum < 0) {
                this.yNum++;
                this.startDate = GetYear(this.yNum);
                this.time = GetYear(this.yNum);
            }
            this.getData();
            this.checkOpacity();
        },
        changeTimeType(num) {
            this.activeTime = num;
            if (this.activeTime == 1) {
                this.startDate = getNWeekFirstDay(this.wNum);
                this.endDate = getNWeekLastDay(this.wNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            }
            if (this.activeTime == 2) {
                this.startDate = getMonthStartDay(this.mNum);
                this.endDate = getMonthEndDay(this.mNum);
                this.time = changeMonthDate(this.startDate);
            }
            if (this.activeTime == 0) {
                this.startDate = GetDateStr(this.tNum);
                this.endDate = GetDateStr(this.tNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
            }
            if (this.activeTime == 3) {
                this.startDate = GetYear(this.yNum);
                this.time = GetYear(this.yNum);
            }
            this.getData();
            this.checkOpacity();
        },
        getData() {
            this.mathData = {}
            this.$api.status.getVitalSignsByRange({
                type: this.activeTime == 1 ? 'week' : this.activeTime == 2 ? 'month' : 'year',
                startDate: this.startDate,
                endDate: this.endDate
            }).then(res => {
                this.info = res.info || {}
                if (res.info && res.info.vitalSignsRangeMath && res.info.vitalSignsRangeMath.hrAvg > 0) {
                    this.noData = false
                } else {
                    this.noData = true
                }
                // 根据时间范围生成 xData
                let xData = [];
                if (this.activeTime == 3) {
                    // year 模式：12个月
                    for (let i = 1; i <= 12; i++) {
                        xData.push(i);
                    }
                } else {
                    // week / month 模式：按天生成
                    let startTs = new Date(this.startDate).getTime();
                    let endTs = new Date(this.endDate).getTime();
                    for (let ts = startTs; ts <= endTs; ts += 86400000) {
                        let dateStr = new Date(ts).toISOString().slice(0, 10);
                        let week = getDateWeek(dateStr);
                        let weekStr = this.$t('sleep.week' + week);
                        xData.push(weekStr + '\n' + getDateDay(dateStr));
                    }
                }
                this.$nextTick(function () {
                    this.drawHrAvgChart(xData, (res.info.hrAvgList || []).map(v => v === 0 ? null : v));
                    this.drawHrvChart(xData, (res.info.hrvAvgList || []).map(v => v === 0 ? null : v));
                    this.drawHrChart(xData, (res.info.hrDeepAvgList || []).map(v => v === 0 ? null : v));
                    this.drawRespChart(xData, (res.info.respRateDeepAvgList || []).map(v => v === 0 ? null : v));
                })
            })
        },
        drawHrAvgChart(xData, yData) {
            let _this = this;
            if (this.hrAvgChart) {
                this.hrAvgChart.dispose();
            }
            this.hrAvgChart = this.$echarts.init(document.getElementById("hr-avg-chart"));
            if (!this.noData) {
                this.hrAvgChart.setOption({
                    grid: {
                        top: 16 * this.ratio,
                        bottom: 42 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    legend: {
                        top: 12 * this.ratio,
                        itemWidth: 15 * this.ratio,
                        itemHeight: 8 * this.ratio,
                        textStyle: {
                            color: getSkin('--text-color-2'),
                            fontSize: 11 * this.ratio,
                            fontFamily: "'D-D','SF'",
                        },
                        itemGap: 32 * this.ratio,
                    },
                    dataZoom: {
                        type: 'inside'
                    },
                    emphasis: {
                        disabled: true,
                    },
                    tooltip: {
                        borderColor: 'transparent',
                        backgroundColor: getSkin('--bg-color-3'),
                        trigger: 'axis',
                        position: (point, params, dom, rect, size) => {
                            let x = point[0] - size.contentSize[0] / 2;
                            let cWidth = 375 * _this.ratio;
                            if (x < 0) {
                                x = 0;
                            } else if ((x + size.contentSize[0]) > cWidth) {
                                x = cWidth - size.contentSize[0];
                            }
                            return [x, '0%'];
                        },
                        formatter: function (params, ticket, callback) {
                            let item = params[0];
                            let value = item.data ? item.data : 0;
                            if (value == 0) {
                                return
                            }
                            let html = '';
                            html += '<div style="font-size:13px;font-family:D-D;color: ' + getSkin('--text-color-2') + '">' + item.axisValue + '</div>'
                            html += '<div><div style="display: inline-block;font-size:13px;color: ' + getSkin('--text-color-2') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + value + '</span> bpm </div></div>';
                            return html
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            fontFamily: "'D-D','SF'",
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        boundaryGap: [0, '10%'],
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3'),
                            }
                        },
                        splitNumber: 4,
                        axisLabel: {
                            fontSize: 11,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false,
                            fontFamily: "'D-D','SF'",
                        }
                    },
                    series: [
                        {
                            data: yData,
                            type: 'line',
                            symbol: 'circle', // 标记点形状：圆形
                            symbolSize: 7 * this.ratio,   // 标记点大小
                            itemStyle: {
                                // 关键：填充色设为透明，描边色设为蓝色
                                color: getSkin('--bg-color-2'),
                                borderColor: getSkin('--chart-color-3'), // 描边颜色（和你的折线颜色一致）
                                borderWidth: 2          // 描边粗细，控制圆环宽度
                            },
                            lineStyle: {
                                color: getSkin('--chart-color-3'), // 折线颜色
                            },
                            areaStyle: {
                                color: this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                                    {
                                        offset: 0,
                                        color: 'rgba(241, 74, 97, 0)',
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(241, 74, 97, 0.7)',
                                    },
                                ]),
                            },
                            label: {
                                show: true,
                                position: 'top',
                                color: getSkin('--text-color-1'),
                                fontSize: 11 * this.ratio,
                                fontWeight: 'bold',
                                formatter: (params) => {
                                    return params.value;
                                }
                            },
                        }
                    ]
                }, true)
            } else {
                this.hrAvgChart.setOption({
                    grid: {
                        top: 16 * this.ratio,
                        bottom: 42 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    title: {
                        text: this.$t('noData'),
                        x: 'center',
                        y: 70 * this.ratio,
                        textStyle: {
                            fontFamily: 'Manteka',
                            fontSize: '12',
                            fontWeight: 'normal',
                            color: getSkin('--text-color-2')
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        max: 120,
                        boundaryGap: [0, '10%'],
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false
                        }
                    },
                    series: [
                        {
                            data: [],
                            type: 'line',
                        }
                    ]
                }, true)
            }
        },
        drawHrvChart(xData, yData) {
            let _this = this;
            if (this.hrvChart) {
                this.hrvChart.dispose();
            }
            this.hrvChart = this.$echarts.init(document.getElementById("hrv-chart"));
            if (!this.noData) {
                this.hrvChart.setOption({
                    grid: {
                        top: 16 * this.ratio,
                        bottom: 42 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    legend: {
                        top: 12 * this.ratio,
                        itemWidth: 15 * this.ratio,
                        itemHeight: 8 * this.ratio,
                        textStyle: {
                            color: getSkin('--text-color-2'),
                            fontSize: 11 * this.ratio,
                            fontFamily: "'D-D','SF'",
                        },
                        itemGap: 32 * this.ratio,
                    },
                    dataZoom: {
                        type: 'inside'
                    },
                    emphasis: {
                        disabled: true,
                    },
                    tooltip: {
                        borderColor: 'transparent',
                        backgroundColor: getSkin('--bg-color-3'),
                        trigger: 'axis',
                        position: (point, params, dom, rect, size) => {
                            let x = point[0] - size.contentSize[0] / 2;
                            let cWidth = 375 * _this.ratio;
                            if (x < 0) {
                                x = 0;
                            } else if ((x + size.contentSize[0]) > cWidth) {
                                x = cWidth - size.contentSize[0];
                            }
                            return [x, '0%'];
                        },
                        formatter: function (params, ticket, callback) {
                            let item = params[0];
                            let value = item.data ? item.data : 0;
                            if (value == 0) {
                                return
                            }
                            let html = '';
                            html += '<div style="font-size:13px;font-family:D-D;color: ' + getSkin('--text-color-2') + '">' + item.axisValue + '</div>'
                            html += '<div><div style="display: inline-block;font-size:13px;color: ' + getSkin('--text-color-2') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + value + '</span> ms </div></div>';
                            return html
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11,
                            color: getSkin('--text-color-3'),
                            fontFamily: "'D-D','SF'",
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        boundaryGap: [0, '10%'],
                        interval: 25,
                        max: 100,
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3'),
                            }
                        },
                        axisLabel: {
                            fontSize: 11,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false,
                            fontFamily: "'D-D','SF'",
                        }
                    },
                    series: [
                        {
                            data: yData,
                            type: 'line',
                            symbol: 'circle', // 标记点形状：圆形
                            symbolSize: 7 * this.ratio,   // 标记点大小
                            itemStyle: {
                                // 关键：填充色设为透明，描边色设为蓝色
                                color: getSkin('--bg-color-2'),
                                borderColor: getSkin('--chart-color-8'), // 描边颜色（和你的折线颜色一致）
                                borderWidth: 2          // 描边粗细，控制圆环宽度
                            },
                            lineStyle: {
                                color: getSkin('--chart-color-8'), // 折线颜色
                            },
                            areaStyle: {
                                color: this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                                    {
                                        offset: 0,
                                        color: 'rgba(34, 172, 251, 0)',
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(34, 172, 251, 0.70)',
                                    },
                                ]),
                            },
                            label: {
                                show: true,
                                position: 'top',
                                color: getSkin('--text-color-1'),
                                fontSize: 11 * this.ratio,
                                fontWeight: 'bold',
                                formatter: (params) => {
                                    return params.value + '%';
                                }
                            },
                        }
                    ]
                }, true)
            } else {
                this.hrvChart.setOption({
                    grid: {
                        top: 16 * this.ratio,
                        bottom: 42 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    title: {
                        text: this.$t('noData'),
                        x: 'center',
                        y: 70 * this.ratio,
                        textStyle: {
                            fontFamily: 'Manteka',
                            fontSize: '12',
                            fontWeight: 'normal',
                            color: getSkin('--text-color-2')
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        max: 100,
                        boundaryGap: [0, '10%'],
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false
                        }
                    },
                    series: [
                        {
                            data: [],
                            type: 'line',
                        }
                    ]
                }, true)
            }
        },
        drawHrChart(xData, yData) {
            let _this = this;
            if (this.hrChart) {
                this.hrChart.dispose();
            }
            this.hrChart = this.$echarts.init(document.getElementById("hr-chart"));
            if (!this.noData) {
                this.hrChart.setOption({
                    grid: {
                        top: 16 * this.ratio,
                        bottom: 42 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    legend: {
                        top: 12 * this.ratio,
                        itemWidth: 15 * this.ratio,
                        itemHeight: 8 * this.ratio,
                        textStyle: {
                            color: getSkin('--text-color-2'),
                            fontSize: 11 * this.ratio,
                            fontFamily: "'D-D','SF'",
                        },
                        itemGap: 32 * this.ratio,
                    },
                    dataZoom: {
                        type: 'inside'
                    },
                    emphasis: {
                        disabled: true,
                    },
                    tooltip: {
                        borderColor: 'transparent',
                        backgroundColor: getSkin('--bg-color-3'),
                        trigger: 'axis',
                        position: (point, params, dom, rect, size) => {
                            let x = point[0] - size.contentSize[0] / 2;
                            let cWidth = 375 * _this.ratio;
                            if (x < 0) {
                                x = 0;
                            } else if ((x + size.contentSize[0]) > cWidth) {
                                x = cWidth - size.contentSize[0];
                            }
                            return [x, '0%'];
                        },
                        formatter: function (params, ticket, callback) {
                            let item = params[0];
                            let value = item.data ? item.data : 0;
                            if (value == 0) {
                                return
                            }
                            let html = '';
                            html += '<div style="font-size:13px;font-family:D-D;color: ' + getSkin('--text-color-2') + '">' + item.axisValue + '</div>'
                            html += '<div><div style="display: inline-block;font-size:13px;color: ' + getSkin('--text-color-2') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + value + '</span> bpm </div></div>';
                            return html
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11,
                            color: getSkin('--text-color-3'),
                            fontFamily: "'D-D','SF'",
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        boundaryGap: [0, '10%'],
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3'),
                            }
                        },
                        splitNumber: 4,
                        axisLabel: {
                            fontSize: 11,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false,
                            fontFamily: "'D-D','SF'",
                        }
                    },
                    series: [
                        {
                            data: yData,
                            type: 'line',
                            symbol: 'circle', // 标记点形状：圆形
                            symbolSize: 7 * this.ratio,   // 标记点大小
                            itemStyle: {
                                // 关键：填充色设为透明，描边色设为蓝色
                                color: getSkin('--bg-color-2'),
                                borderColor: getSkin('--chart-color-3'), // 描边颜色（和你的折线颜色一致）
                                borderWidth: 2          // 描边粗细，控制圆环宽度
                            },
                            lineStyle: {
                                color: getSkin('--chart-color-3'), // 折线颜色
                            },
                            areaStyle: {
                                color: this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                                    {
                                        offset: 0,
                                        color: 'rgba(241, 74, 97, 0)',
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(241, 74, 97, 0.7)',
                                    },
                                ]),
                            },
                            label: {
                                show: true,
                                position: 'top',
                                color: getSkin('--text-color-1'),
                                fontSize: 11 * this.ratio,
                                fontWeight: 'bold',
                                formatter: (params) => {
                                    return params.value;
                                }
                            },
                        }
                    ]
                }, true)
            } else {
                this.hrChart.setOption({
                    grid: {
                        top: 16 * this.ratio,
                        bottom: 42 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    title: {
                        text: this.$t('noData'),
                        x: 'center',
                        y: 70 * this.ratio,
                        textStyle: {
                            fontFamily: 'Manteka',
                            fontSize: '12',
                            fontWeight: 'normal',
                            color: getSkin('--text-color-2')
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        max: 100,
                        boundaryGap: [0, '10%'],
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false
                        }
                    },
                    series: [
                        {
                            data: [],
                            type: 'line',
                        }
                    ]
                }, true)
            }
        },
        drawRespChart(xData, yData) {
            let _this = this;
            if (this.respChart) {
                this.respChart.dispose();
            }
            this.respChart = this.$echarts.init(document.getElementById("resp-chart"));
            if (!this.noData) {
                this.respChart.setOption({
                    grid: {
                        top: 16 * this.ratio,
                        bottom: 42 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    legend: {
                        top: 12 * this.ratio,
                        itemWidth: 15 * this.ratio,
                        itemHeight: 8 * this.ratio,
                        textStyle: {
                            color: getSkin('--text-color-2'),
                            fontSize: 11 * this.ratio,
                            fontFamily: "'D-D','SF'",
                        },
                        itemGap: 32 * this.ratio,
                    },
                    dataZoom: {
                        type: 'inside'
                    },
                    emphasis: {
                        disabled: true,
                    },
                    tooltip: {
                        borderColor: 'transparent',
                        backgroundColor: getSkin('--bg-color-3'),
                        trigger: 'axis',
                        position: (point, params, dom, rect, size) => {
                            let x = point[0] - size.contentSize[0] / 2;
                            let cWidth = 375 * _this.ratio;
                            if (x < 0) {
                                x = 0;
                            } else if ((x + size.contentSize[0]) > cWidth) {
                                x = cWidth - size.contentSize[0];
                            }
                            return [x, '0%'];
                        },
                        formatter: function (params, ticket, callback) {
                            let item = params[0];
                            let value = item.data ? item.data : 0;
                            if (value == 0) {
                                return
                            }
                            let html = '';
                            html += '<div style="font-size:13px;font-family:D-D;color: ' + getSkin('--text-color-2') + '">' + item.axisValue + '</div>'
                            html += '<div><div style="display: inline-block;font-size:13px;color: ' + getSkin('--text-color-2') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + value + '</span> </div></div>';
                            return html
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11,
                            color: getSkin('--text-color-3'),
                            fontFamily: "'D-D','SF'",
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        boundaryGap: [0, '10%'],
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3'),
                            }
                        },
                        splitNumber: 4,
                        axisLabel: {
                            fontSize: 11,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false,
                            fontFamily: "'D-D','SF'",
                        }
                    },
                    series: [
                        {
                            data: yData,
                            type: 'line',
                            symbol: 'circle', // 标记点形状：圆形
                            symbolSize: 7 * this.ratio,   // 标记点大小
                            itemStyle: {
                                // 关键：填充色设为透明，描边色设为蓝色
                                color: getSkin('--bg-color-2'),
                                borderColor: getSkin('--chart-color-1'), // 描边颜色（和你的折线颜色一致）
                                borderWidth: 2          // 描边粗细，控制圆环宽度
                            },
                            lineStyle: {
                                color: getSkin('--chart-color-1'), // 折线颜色
                            },
                            areaStyle: {
                                color: this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                                    {
                                        offset: 0,
                                        color: getSkin('--chart-color-1p1'),
                                    },
                                    {
                                        offset: 1,
                                        color: getSkin('--chart-color-1p7'),
                                    },
                                ]),
                            },
                            label: {
                                show: true,
                                position: 'top',
                                color: getSkin('--text-color-1'),
                                fontSize: 11 * this.ratio,
                                fontWeight: 'bold',
                                formatter: (params) => {
                                    return params.value;
                                }
                            },
                        }
                    ]
                }, true)
            } else {
                this.respChart.setOption({
                    grid: {
                        top: 16 * this.ratio,
                        bottom: 42 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    title: {
                        text: this.$t('noData'),
                        x: 'center',
                        y: 70 * this.ratio,
                        textStyle: {
                            fontFamily: 'Manteka',
                            fontSize: '12',
                            fontWeight: 'normal',
                            color: getSkin('--text-color-2')
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        max: 100,
                        boundaryGap: [0, '10%'],
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false
                        }
                    },
                    series: [
                        {
                            data: [],
                            type: 'line',
                        }
                    ]
                }, true)
            }
        }
    },
}
</script>

<style scoped>
.content {
    padding-top: 96px;
}

.time-select {
    text-align: center;
    padding-top: 12px;
    position: relative;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.suggest-title {
    color: var(--text-color-2);
    font-size: 15px;
    margin-left: 15px;
    margin-top: 16px;
    letter-spacing: 2px;
    display: flex;
}

.vs-line {
    display: flex;
    justify-content: space-between;
}

.vs-text {
    font-size: 11px;
    color: var(--text-color-3);
    margin-right: 16px;
}

.avg-duration-title {
    font-size: 13px;
    color: var(--text-color-1);
    padding-top: 16px;
    margin-left: 16px;
    margin-bottom: 4px;
}

.avg-efficiency-value {
    font-size: 20px;
    color: var(--text-color-1);
    margin-left: 16px;
}

.avg-efficiency-unit {
    font-size: 13px;
    color: var(--text-color-1);
    margin-left: 4px;
    margin-right: 8px;
}

.avg-efficiency-compare {
    background: var(--chart-color-1p1);
    border-radius: 3px 3px 3px 3px;
    color: var(--chart-color-1);
    font-size: 13px;
    padding: 2px 4px;
}

.avg-efficiency-line {
    display: flex;
    align-items: center;
}

.avg-efficiency-compare-value {
    margin-left: 5px;
}

.score-chart-box {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 10px 10px 10px 10px;
    margin: 13px auto 20px;
}

.hr-chart {
    width: 345px;
    height: 196px;
}
</style>



// WEBPACK FOOTER //
// src/views/status/33vitalSignsRange.vue